export const APP_EVENTS = {
  SEARCH_ENTER_PRESSED: "search-enter-pressed",
  ACCOUNT_STATUS_CHANGED: "account-status-changed",
};
export enum KeyboardEvent {
  ARROW_DOWN = "ArrowDown",
  ARROW_UP = "ArrowUp",
  ENTER = "Enter",
  ESCAPE = "Escape",
}

export function subscribeOnEnter($input: HTMLInputElement, callback: () => void) {
  $input.onkeydown = function (event) {
    if (event.key === KeyboardEvent.ENTER) {
      callback();
    }
  };
}

// Examples:
//  const debouncedSearch = debounce(handleSearch, 500);
//  debouncedSearch(1, 2, 3)

export function debounce<T extends (...args: any[]) => void>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>;

  return function (...args: Parameters<T>) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}
